import './Upload.css';
import { useState, useRef } from 'react';
import SERVER_URL from '../../../../env.js';
import parseQuestionsFile from '../../../../Utils/FileUtil.js';
import Cookies from 'js-cookie';

function Upload({ toggleNav, closeCreate, setQuestions }) {
    const [question, setQuestion] = useState('');
    const [topic, setTopic] = useState('');
    const [parsedQuestions, setParsedQuestions] = useState([]);
    const [updateMessage, setUpdateMessage] = useState('');
    const fileInputRef = useRef(null);
    const [chosenFile, setChosenFile] = useState(null);

    const handleTopicChange = (event) => {
        setTopic(event.target.value);
    };
    const handleQuestionChange = (event) => {
        setQuestion(event.target.value);
    };

    const handleQuestionFile = (event) => {
        const file = event.target.files[0]
        if (!file) return
        setChosenFile(file)
        const fileExtension = file.name.split('.').pop().toLowerCase()
        const fileType = file.type || null
        if (!fileExtension.includes('txt') || !fileType.includes('text/plain')) {
            alert('Please upload a .txt file type.')
            return
        }
        const fileReader = new FileReader()
        fileReader.onload = (event) => {
            const text = event.target.result
            if (fileExtension.includes('txt') && fileType.includes('text/plain') && text) {
                setParsedQuestions(parseQuestionsFile(text))
            }
        }
        fileReader.readAsText(file)
    }

    const handleFileUpload = () => {
        const fileExtension = chosenFile.name.split('.').pop().toLowerCase()
        const fileType = chosenFile.type || null
        if (!fileExtension.includes('txt') || !fileType.includes('text/plain')) {
            return { error: 'Please upload a .txt file type.' }
        }
        if (!parsedQuestions || parsedQuestions.length === 0) {
            return { error: 'No questions found in the file.' }
        }

        fetch(SERVER_URL + '/questions/bulk-upload', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('accessToken'),
            },
            body: JSON.stringify({
                questions: parsedQuestions,
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(errData.error || errData.message || `HTTP error ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setChosenFile('')
                setParsedQuestions([])
                setUpdateMessage(prev => prev + `\nQuestions file uploaded successfully. ${data.questions?.length || 0} new questions added`);
                setQuestions(prev => [...prev, ...data.questions])
                closeCreate()
            })
            .catch((error) => {
                setUpdateMessage(prev => prev + `\nError uploading questions file. ${error.message}`);
            });
    }

    const handleUpload = () => {
        if (chosenFile) {
            const result = handleFileUpload();
            if (result?.error) {
                setUpdateMessage(prev => prev + ' \n' + result.error)
                return;
            }
        }
        if (!question.trim() || !topic.trim()) {
            return;
        }

        fetch(SERVER_URL + '/questions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('accessToken'),
            },
            body: JSON.stringify({
                question: question,
                topic: topic,
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    const errData = await response.json().catch(() => ({}));
                    throw new Error(errData.error || errData.message || `HTTP error ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setUpdateMessage(prev => prev + '\nQuestion uploaded successfully');
                setQuestions(prev => [...prev, data.question])
                closeCreate()
            })
            .catch((error) => {
                setUpdateMessage(prev => prev + `\nError uploading question: ${error.message}`);
            });
    };

    return (
        <div className="Upload">
            {updateMessage && <p className="update-message">{updateMessage}</p>}
            <div className="upload-container">
                <div className="upload-question-text-container">
                    <div className="question-upload-field-group">
                        <label className="upload-field-label" htmlFor="topic-input">Topic <span className="required">*</span></label>
                        <input id="topic-input" className="upload-question-text-input upload-question-topic-input" type="text" onChange={handleTopicChange} placeholder="Topic..." />
                    </div>
                </div>
                <div className="upload-question-container">
                    <div className="question-upload-field-group" style={{ width: '100%' }}>
                        <label className="upload-field-label" htmlFor="question-input">Question <span className="required">*</span></label>
                        <textarea id="question-input" className="upload-question-textarea-input" onChange={handleQuestionChange} placeholder="Question..." />
                    </div>

                    <input ref={fileInputRef} type="file" onChange={handleQuestionFile} style={{ display: 'none' }} />
                    <div className="file-upload" onClick={() => fileInputRef.current.click()}>
                        {chosenFile?.name || 'Choose Question File'}
                    </div>
                </div>
                <button className="upload-submit" onClick={handleUpload}>Add Question</button>
            </div>

        </div>
    );
}

export default Upload;
